import Footer from "./Footer";
import React, { useEffect, useState } from "react";
import { FaWhatsapp } from "react-icons/fa";

const ThankYou = () => {
  const [whatsappLink, setWhatsappLink] = useState("");

  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
    const fetchWhatsappLink = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/whatsapp`);
        const json = await res.json();

        if (json.success && json.data?.link) {
          setWhatsappLink(json.data.link);
        }
      } catch (error) {
        console.error("Failed to fetch WhatsApp link", error);
      }
    };

    fetchWhatsappLink();
  }, []);

  return (
    <div className="min-h-screen bg-white py-10 px-4 md:px-10 flex flex-col items-center text-center">
      <div className="border-2 border-green-500 rounded-xl p-6 md:p-10 max-w-3xl w-full">
        <div className="text-6xl mb-6">🎉</div>
        <h1 className="text-2xl md:text-3xl font-bold mb-4 text-black">
          THANK YOU FOR REGISTERING!
        </h1>

        {/* TOP BUTTON */}
        <a
          href={whatsappLink}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 bg-green-500 text-white text-lg font-semibold px-6 py-3 rounded hover:bg-green-600 transition"
        >
          <FaWhatsapp size={24} /> Join WhatsApp Group
        </a>

        <p className="mt-6 text-gray-700">
          Your registration for the Ayurvedic Weight Loss Webinar is confirmed!
          We’re excited to have you join us on this transformative journey.
        </p>

        <div className="text-left mt-8">
          <h2 className="text-green-600 font-semibold text-xl mb-2">
            Here’s What to Do Next:
          </h2>

          <p className="text-gray-700">
            To ensure you receive your <strong>webinar joining link</strong> and
            other important updates, please take a moment to join our exclusive
            WhatsApp group.
          </p>

          <ul className="mt-4 space-y-2 text-gray-700">
            <li>✅ Your webinar joining link</li>
            <li>✅ Exclusive Ayurvedic weight loss tips</li>
            <li>✅ Daily inspiration to keep you motivated</li>
            <li>✅ A supportive community to help you succeed</li>
          </ul>
        </div>

        {/* BOTTOM BUTTON */}
        <div className="mt-8">
          <a
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-green-500 text-white text-lg font-semibold px-6 py-3 rounded hover:bg-green-600 transition"
          >
            <FaWhatsapp size={24} /> Join WhatsApp Group
          </a>
        </div>
      </div>

      {/* Remaining code unchanged */}
      {/* Bottom Section */}
      <div className="max-w-3xl mt-12 text-left w-full">
        <h2 className="text-xl md:text-2xl font-bold mb-4 text-black">
          Why This Webinar Will Be Life-Changing
        </h2>

        <ul className="space-y-4">
          <li>
            🌿{" "}
            <span className="text-green-600 font-semibold">
              Discover Ayurvedic Wisdom
            </span>
            : Learn natural, sustainable weight loss techniques personalized to
            your body type.
          </li>
          <li>
            ❤️{" "}
            <span className="text-red-500 font-semibold">Enhance Health</span>:
            Unlock the power of emotional balance and meaningful connections to
            support your journey.
          </li>
          <li>
            💡{" "}
            <span className="text-pink-500 font-semibold">
              Master NLP & Mindfulness Practices
            </span>
            : Reprogram your mindset for lasting success and overcome
            challenges.
          </li>
        </ul>

        {/* Quote Box */}
        <div className="border mt-10 border-[#eab308] rounded-xl p-8 text-center bg-white shadow-sm">
          <p className="text-gray-800 font-medium italic text-lg mb-6">
            💡 Your health, happiness, and well-being matter. Let’s embark on
            this journey together and create lasting transformation!
          </p>

          <div className="space-y-1">
            <p className="font-bold text-gray-900 italic">
              With care and gratitude,
            </p>
            <p className="text-[#eab308] font-bold text-xl">[Swapnil Gautam]</p>
            <p className="text-sm font-bold text-gray-800">
              NLP & Mindfulness Expert | Relationship Counselor | Ayurvedic
              Wellness Coach
            </p>
          </div>
        </div>

      </div>
      <Footer />
    </div>
  );
};

export default ThankYou;
